module.exports = __webpack_public_path__ + "static/media/CITF_logo_ENG.66ff455b.svg";